import React, { forwardRef, HTMLProps, ReactNode } from 'react';
import { Breadcrumb, Steps } from '@useblu/ocean-react';

import * as S from './styles';

export type InternalPageProps = {
  title: string;
  description?: string;
  breadcrumbs?: string[] | ReactNode[];

  steps?: any;

  columns?: 6 | 8;
} & HTMLProps<HTMLDivElement>;

const InternalPage = forwardRef<HTMLDivElement, InternalPageProps>(
  (
    { children, title, description, columns = 6, breadcrumbs, steps, ...rest },
    ref,
  ) => {
    return (
      <S.Wrapper $columns={columns} className={rest.className} ref={ref}>
        {breadcrumbs && (
          <div className="navigation__container">
            <Breadcrumb items={breadcrumbs} />
          </div>
        )}

        {steps && (
          <div className="steps__container">
            <Steps {...steps} />
          </div>
        )}

        <div className="texts__container">
          <S.Title>{title}</S.Title>
          {description && <S.Description>{description}</S.Description>}
        </div>

        <div className="page__container">{children}</div>
      </S.Wrapper>
    );
  },
);

InternalPage.displayName = 'InternalPage';

export default InternalPage;
